<template>
  <div class="reports-design-help-section" v-if="show">
    <div class="reports-design-help-title reports-design-help-toggle" v-b-toggle.help-escpos>
      <AppIcon name="receipt" /> ESC/POS
      <AppIcon name="chevron-down" class="reports-design-help-chevron" />
    </div>
    <b-collapse id="help-escpos" accordion="help-accordion">
      <div class="reports-design-help-item">
        <code>[[align=left]] / [[align=center]] / [[align=right]]</code>
        <span>Define la alineación de las líneas siguientes. Atajos equivalentes: <strong>[[left]]</strong>, <strong>[[center]]</strong>, <strong>[[right]]</strong>.</span>
      </div>
      <div class="reports-design-help-item">
        <code>[[bold]]texto[[/bold]]</code>
        <span>Negrita. Equivalentes: <strong>[[bold=1]]</strong> / <strong>[[bold:on]]</strong> para activarla y <strong>[[bold=0]]</strong> / <strong>[[bold:off]]</strong> para desactivarla.</span>
      </div>
      <div class="reports-design-help-item">
        <code>[[font=small]]texto[[font=normal]]</code>
        <span>Usa la fuente compacta.</span>
      </div>
      <div class="reports-design-help-item">
        <code>[[big]]texto[[/big]]</code>
        <span>Texto a doble alto y ancho (equivale a <strong>[[size=2]]</strong>). También hay tamaños parciales: <strong>[[size=dh]]</strong> (solo doble alto) y <strong>[[size=dw]]</strong> (solo doble ancho). Para volver al tamaño normal también sirve <strong>[[size=1]]</strong>.</span>
      </div>
      <div class="reports-design-help-item">
        <code>[[hr]]</code>
        <span>Línea horizontal, del ancho completo del ticket.</span>
      </div>
      <div class="reports-design-help-item">
        <code>izquierda[[col]]derecha</code>
        <span>Dos columnas en la misma línea: separa con <strong>[[col]]</strong> el texto pegado al margen izquierdo del pegado al derecho. Usalo una sola vez por línea.</span>
      </div>
      <div class="reports-design-help-item">
        <code>izquierda[[col=small]]derecha</code>
        <span>Igual que <strong>[[col]]</strong>, pero calcula el ancho para texto con <strong>[[font=small]]</strong>. Usalo cuando ambos importes se imprimen con fuente compacta.</span>
      </div>
      <div class="reports-design-help-item">
        <code>[[qrcode=contenido]]</code>
        <span>Imprime un QR nativo de la térmica (no una imagen). Factura A usa el contenido fiscal de ARCA.</span>
      </div>
      <div class="reports-design-help-item">
        <code>[[feed=N]]</code>
        <span>Avanza <strong>N</strong> líneas en blanco.</span>
      </div>
      <div class="reports-design-help-item">
        <code>[[line-spacing=N]] / [[line-spacing=default]]</code>
        <span>Define el interlineado de las líneas siguientes en unidades ESC/POS. <strong>[[line-spacing=default]]</strong> restaura el valor estándar de la impresora.</span>
      </div>
      <div class="reports-design-help-item">
        <code>[[feed-dots=N]]</code>
        <span>Avanza físicamente <strong>N</strong> unidades de papel en ese punto, sin agregar una línea en blanco. Sirve para separar dos renglones puntualmente.</span>
      </div>
      <div class="reports-design-help-item">
        <code>[[cut]] / [[cut=full]]</code>
        <span>Corta el papel completo.</span>
      </div>
      <div class="reports-design-help-item">
        <code>[[cut=partial]]</code>
        <span>Corte parcial (deja una pestaña de papel sin cortar).</span>
      </div>
      <div class="reports-design-help-item">
        <code>[[no-init]]</code>
        <span>Omite únicamente el reset general de la impresora al inicio. La alineación y la tabla de caracteres (CP850, para español) siempre se aplican igual.</span>
      </div>
      <div class="reports-design-help-note">
        También admite las mismas variables que PDF: <code v-pre>{{variable}}</code> y bloques repetibles con <code v-pre>{{details|arrayStart}}</code> / <code v-pre>{{details|arrayEnd}}</code>.<br>
        Cualquier <code>[[...]]</code> que no coincida exactamente con alguno de estos tags se imprime tal cual, como texto literal.
      </div>
    </b-collapse>
  </div>
</template>

<script>
import AppIcon from '@/components/inc/icon/AppIcon'

export default {
  name: 'EscposHelpAccordion',
  components: { AppIcon },
  props: {
    show: { type: Boolean, default: false },
  },
}
</script>
